import { FormFieldViewInfoFieldType } from './types';
export const isEmptyField = (type, fieldValue) => {
    if (type === FormFieldViewInfoFieldType.PHONE_COUNTRY_CODE) {
        return (isEmptyField(FormFieldViewInfoFieldType.TEXT, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.countryCode) ||
            isEmptyField(FormFieldViewInfoFieldType.TEXT, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.phone));
    }
    return (fieldValue === undefined || // not selected at all
        fieldValue === '' || // string
        fieldValue === false || // boolean
        (Array.isArray(fieldValue) && fieldValue.length === 0));
};
//# sourceMappingURL=utils.js.map